// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import { CheckboxInput } from 'components/forms/form-elements';

export default class CheckableActions extends React.PureComponent {
  constructor() {
    super();

    this.toggleChecked = this.toggleChecked.bind(this);
  }

  toggleChecked() {
    const { list, update } = this.props;
    const anyChecked = _.some(list, 'checked');
    const updates = _.map(list, item => ({ ...item, checked: !anyChecked, lastChecked: false }));

    update(updates);
  }

  render() {
    const { children, list } = this.props;
    const anyChecked = _.some(list, 'checked');

    if (!anyChecked) return null;

    return (
      <div className="checkbox-table-actions">
        <CheckboxInput input={{ value: anyChecked, onChange: this.toggleChecked }} />
        {children}
      </div>
    );
  }
}

CheckableActions.propTypes = {
  list: PropTypes.array,
  children: PropTypes.node,
  update: PropTypes.func
};
